import { request, gql } from "graphql-request";
import useSWR from "swr";
import type { bazResolver } from "@/lib/server-queries";

type ContinentsApiResponse = { continents: { code: string; name: string }[] };

const API_ENDPOINT = "/api/graphql";

const CONTINENTS_API_ENDPOINT = "https://countries.trevorblades.com/graphql";
const CONTINENTS_QUERY = gql`
  query MyQuery {
    continents {
      code
      name
    }
  }
`;

const fetcher = (query: string, url = API_ENDPOINT) => request(url, query);

/**
 * Usage:
 * const { data, isLoading, isError } = useContinents();
 */
export const useContinents = () => {
  const { data, error } = useSWR<ContinentsApiResponse>(
    [CONTINENTS_QUERY, CONTINENTS_API_ENDPOINT],
    fetcher
  );
  if (error) console.error(error);
  return {
    data: data?.continents,
    isLoading: !error && !data,
    isError: error,
  };
};

const MIN_POSTS_QUERY = gql`
  query PostsQuery {
    allPosts {
      title
      slug
      createdAt
    }
  }
`;

export const usePosts = () => {
  const { data, error } = useSWR<{ allPosts: Awaited<ReturnType<typeof bazResolver>> }>(
    [MIN_POSTS_QUERY],
    fetcher
  );
  if (error) console.error(error);
  return {
    data: data?.allPosts,
    isLoading: !error && !data,
    isError: error,
  };
};
